// Default error message to show when parsing of a task activity fails
export const parseErrorMessage = 'Unknown error'
